export type FileType = 'directory' | 'file' | 'email';

export enum ContentType {
    ImageJpeg = 'image/jpeg',
    ImagePng = 'image/png',
    VideoMp4 = 'video/mp4',
    ApplicationJson = 'application/json',
    ApplicationPdf = 'application/pdf',
    TextMarkdown = 'text/markdown',
    TextPlain = 'text/plain',
}

export type ServerFile = {
    fileId: number;
    name: string;
    path: string;
    parentPath: string;
    type: FileType;
    etag: string;
    lastmod: string;
    contenttype?: ContentType | string;
    contentlength: number;
    selected: boolean;
    shared: boolean;
};

export type RenameFileData = {
    initialPath: string;
    newFilename: string;
};

export type CreateFolderData = {
    path: string;
    folderName: string;
};

export type FileItem = {
    id?: string; // ? exists in some places but not others
    name: string;
    type: FileType;
    contenttype: string;
    content: ArrayBuffer;
    parentPath?: string; // exists in some places but not others
    lastmod?: Date; // exists in some places but not others
    path?: string; // exists in some places but not others
    selected: boolean; // does not seem to be used anywhere
    contentlength?: number; // exists in some places but not others
};
